/**
 * 全局音乐律动 + 键盘子应用 V1 音乐律动：仅在 Electron 桌面端执行。
 * 浏览器环境一律视为未启用，避免 WebHID 授权与音频采集。
 */
export function isDesktopMusicRhythmRuntime(): boolean {
  if (typeof window === "undefined") return false;
  const w = window as Window & {
    electronBridge?: unknown;
    electronAPI?: unknown;
  };
  if (w.electronBridge) return true;
  if (w.electronAPI) return true;
  if (
    typeof navigator !== "undefined" &&
    /electron/i.test(navigator.userAgent)
  ) {
    return true;
  }
  return false;
}
